import { render } from "./about-en.vue?vue&type=template&id=a684852a&scoped=true"
import script from "./about-en.vue?vue&type=script&lang=js"
export * from "./about-en.vue?vue&type=script&lang=js"

import "./about-en.vue?vue&type=style&index=0&id=a684852a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a684852a"]])

export default __exports__